import React, { PropsWithChildren } from 'react';

import { EventCatcherScope } from '@repo/event-processor';

import Footer from 'components/AiTools/RigthPanel/Footer';
import Header from 'components/AiTools/RigthPanel/Header';
import { Wrapper } from 'components/AiTools/RigthPanel/styles';
import { RightPanelProps } from 'components/AiTools/RigthPanel/types';

const RightPanel = <Tab extends string>(
  props: PropsWithChildren<RightPanelProps<Tab>>
): JSX.Element => {
  return (
    <EventCatcherScope feature="aiToolsRightPanel">
      <Wrapper>
        <Header
          activeTab={props.activeTab}
          tabs={props.tabs}
          onTabClick={props.setActiveTab}
        />
        {props.children}
        <Footer
          buttonIcon={props.buttonIcon}
          buttonLabel={props.buttonLabel}
          isDisabled={props.disabled}
          isLoading={props.isLoading}
          small={!!props.smallFooter}
          onClick={props.onClick}
        />
      </Wrapper>
    </EventCatcherScope>
  );
};

export default RightPanel;
